import { CommonModule } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA, EventEmitter, inject, Input, Output, ViewChild,} from '@angular/core';
import { FormArray, FormBuilder, FormGroup, ReactiveFormsModule, Validators,} from '@angular/forms';
import { ExternalDropdownComponent, CommonCommentsComponent, SingleDatePickerComponent } from '@loup-transload-ui-app/common-components';
import { CreateLaneTwistyComponent } from './create-lane-twisty/create-lane-twisty.component';
import { SnackbarService } from '@loup-transload-ui-app/common-services';

@Component({
  selector: 'app-shipment-details-form',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, ExternalDropdownComponent, CreateLaneTwistyComponent, SingleDatePickerComponent, CommonCommentsComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './shipment-details-form.component.html',
  styleUrl: './shipment-details-form.component.scss',
})

export class ShipmentDetailsFormComponent {
  @ViewChild('commodityDropdown') commodityDropdown: ExternalDropdownComponent;
  @ViewChild('twistyComponent') twistyComponent: CreateLaneTwistyComponent;
  @ViewChild('businessDropdown') businessDropdown: ExternalDropdownComponent;
  @ViewChild('datepicker') datepicker: SingleDatePickerComponent;
  @ViewChild('commonComments') commonComments: CommonCommentsComponent;
  @Input() formGroup!: FormGroup;
  @Input() isSubmitted = false;
  @Output() back = new EventEmitter<void>();
  @Output() resetAction = new EventEmitter<void>();
  @Output() submitFinal = new EventEmitter<void>();

  private snackbar = inject(SnackbarService);
  public serviceTypeLabel = 'Commodity Category';
  public businessDurationLabel = 'Business Duration';
  public activeLaneIndex = 0;
  public isRailSelected = false;

  constructor(private fb: FormBuilder) {}

  createLane(): void {
    const newLane = this.fb.group({
      origin: ['', Validators.required],
      destination: ['', Validators.required],
      transloadingServicesRequired: [
        { origin: false, destination: false, no: false },
        Validators.required,
      ],
      truckingServicesRequired: [
        { origin: false, destination: false, no: false },
        Validators.required,
      ],
      storageServicesRequired: [
        { origin: false, destination: false, no: false },
      ],
      potentialUnits: ['', Validators.required],
      unitOfMeasure: ['', Validators.required],
      timeFrame: ['', Validators.required],
    });
    this.lanes.push(newLane);
    this.activeLaneIndex = this.lanes.length - 1;
  }

  get lanes(): FormArray {
    return this.formGroup.get('lanes') as FormArray;
  }

copyLane(index: number): void {
  const laneValue = this.lanes.at(index).value;
  this.lanes.insert(index + 1, this.fb.group({
    origin: structuredClone(laneValue.origin), 
    destination: structuredClone(laneValue.destination),
    transloadingServicesRequired: { ...laneValue.transloadingServicesRequired },
    truckingServicesRequired: { ...laneValue.truckingServicesRequired },
    storageServicesRequired: { ...laneValue.storageServicesRequired },
    potentialUnits: laneValue.potentialUnits,
    unitOfMeasure: laneValue.unitOfMeasure,
    timeFrame: laneValue.timeFrame
  }));
    this.activeLaneIndex = this.lanes.length - 1;
  }

  deleteLane(index: number): void {
    if (this.lanes.length > 1) {
      this.lanes.removeAt(index);
      if (this.activeLaneIndex >= this.lanes.length) {
        this.activeLaneIndex = this.lanes.length - 1;
      }
    } else {
      const message = `Cannot delete the this Lane.`;
      this.snackbar.show(message, 9000, 'bottom');
    }
  }

  onSelected(event: any, fieldName: string) {
    if (event && event.length > 0) {
      this.formGroup.get(fieldName)?.setValue(event[0]);
      this.formGroup.get(fieldName)?.markAsTouched();
    } else {
      this.formGroup.get(fieldName)?.setValue(event);
      this.formGroup.get(fieldName)?.markAsTouched();
    }
  }

  onRadioSelect(selected: boolean) {
    if (selected) {
      this.formGroup.get('includeRailPricing')?.setValue(true);
      this.isRailSelected = true;
    } else {
      this.formGroup.get('includeRailPricing')?.setValue(false);
      this.isRailSelected = false;
    }
  }

  changedDate(event) {
    this.formGroup.get('estimatedStartDate')?.setValue(event);
  }

  commentData(event) {
    this.formGroup.get('comments')?.setValue(event);
  }

  submitAction() {
    this.isSubmitted = true;
    if (this.formGroup.valid) {
      this.submitFinal.emit();
    }
  }
}
